import { render } from "./ScanningSlot.vue?vue&type=template&id=86b4b5ec&scoped=true&ts=true&lang=pug"
import script from "./ScanningSlot.vue?vue&type=script&lang=ts"
export * from "./ScanningSlot.vue?vue&type=script&lang=ts"

import "./ScanningSlot.vue?vue&type=style&index=0&id=86b4b5ec&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b4b5ec"]])

export default __exports__